import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { skipErrorDialogHeaders } from 'app/core/errors/error.interceptor';
import {
    AppLanguage,
    DEFAULT_LANGUAGE,
} from 'app/core/language/language.types';
import {
    LegalAcceptanceStatus,
    LegalCurrentVersion,
    LegalDocumentType,
} from 'app/models/legal';
import { environment } from 'environments/environment';
import { catchError, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LegalService {
    //O texto é estático, do próprio front: vai sem interceptors, como os
    //arquivos de tradução (ver TranslocoHttpLoader).
    private readonly _staticHttp = new HttpClient(inject(HttpBackend));

    //O aceite é conferido uma vez por sessão, como o aviso de plano.
    acceptanceChecked = false;

    constructor(private readonly _http: HttpClient) {}

    getCurrentVersion(): Observable<LegalCurrentVersion> {
        return this._http.get<LegalCurrentVersion>(
            `${environment.apiUrl}legal/current`,
            { headers: skipErrorDialogHeaders }
        );
    }

    //Consulta de fundo depois do login: sem o diálogo genérico de erro,
    //quem chama segue sem pedir o aceite se falhar.
    getAcceptanceStatus(): Observable<LegalAcceptanceStatus> {
        return this._http.get<LegalAcceptanceStatus>(
            `${environment.apiUrl}legal/acceptance`,
            { headers: skipErrorDialogHeaders }
        );
    }

    accept(version: string): Observable<LegalAcceptanceStatus> {
        return this._http.post<LegalAcceptanceStatus>(
            `${environment.apiUrl}legal/acceptance`,
            { version },
            { headers: skipErrorDialogHeaders }
        );
    }

    //Texto do documento no idioma pedido; sem o arquivo, vale o português.
    getDocument(
        type: LegalDocumentType,
        language: AppLanguage
    ): Observable<string> {
        const load = (lang: AppLanguage) =>
            this._staticHttp.get(`legal/${lang}/${type}.md`, {
                responseType: 'text',
            });

        return language === DEFAULT_LANGUAGE
            ? load(language)
            : load(language).pipe(catchError(() => load(DEFAULT_LANGUAGE)));
    }
}
